import {Component, ChangeDetectionStrategy} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {ChatVersions} from "../../../../../shared/chat.versions";

import {RouterModule} from "@angular/router";
import {TranslatePipe} from "@ngx-translate/core";
import {LANDING_CLUSTERS} from "../landing/landing-clusters";

@Component({
    selector: 'main-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['../main.pages.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    RouterModule,
    TranslatePipe
]
})
export class FooterComponent {
    protected showQ_A = environment.chatVersion === ChatVersions.SX
    protected showBlog = environment.chatVersion === ChatVersions.SX

    // Сквозная строка ссылок на лендинги: даёт им входящие ссылки со всех статических
    // страниц, включая статьи блога. Только SX — в VT-сборке лендингов нет.
    protected landings = environment.chatVersion === ChatVersions.SX ? LANDING_CLUSTERS : []
}
